.loading {
  padding: 40px;
  text-align: center;
}
